<template>
  <template v-for="choice in choices" :key="choice.value">
    <div v-if="isChoiceVisible(choice)" class="checkbox-primary custom-control custom-checkbox">
      <input
        :id="'checkbox-' + itemModel.vars.name + '-' + choice.value"
        v-model="choice.checked"
        :class="
          (itemModel.vars.error ? 'custom-control-input is-invalid' : 'custom-control-input') +
          (itemModel.vars.attr && itemModel.vars.attr.class ? ' ' + itemModel.vars.attr.class : '')
        "
        :disabled="itemModel.vars.disabled || choice.disabled"
        :readonly="(itemModel.vars.attr && itemModel.vars.attr.readonly) || readonly"
        :value="choice.value"
        type="checkbox"
        @change="setChecked"
        @focus="focus"
      />
      <label
        :for="'checkbox-' + itemModel.vars.name + '-' + choice.value"
        :class="
          'custom-control-label ps-2' + (choice.badges ? ' badged' : '') + (truncateChoiceLabel ? ' -truncated' : '')
        "
      >
        <span
          v-tooltip="
            truncateChoiceLabel
              ? { title: choice.label, textWrap: true, onlyIfTruncated: true, position: 'top', forcePosition: true }
              : false
          "
          :tabindex="truncateChoiceLabel ? 0 : null"
          :class="labelTextClass(choice)"
          >{{ choice.label }}</span
        >
        <span
          v-if="choice.badges && choice.badges.length"
          class="custom-control-label__badges d-flex flex-wrap justify-content-end ms-2"
        >
          <span
            v-for="(badge, index) in choice.badges"
            :key="index"
            :class="'badge mb-1 bg-' + (badge?.type ? badge.type : 'success')"
            >{{ badgeLabel(badge) }}</span
          >
        </span>
        <template v-if="choice.attr && choice.attr['data-icon'] && Object.keys(choice.attr['data-icon']).length">
          <span
            v-for="(icon, index) in choice.attr['data-icon']"
            :key="index"
            v-tooltip="{ title: icon.tooltip ? icon.tooltip : '' }"
            :class="'ms-2 ' + (icon.class ? icon.class : '')"
          >
            <FontAwesomeIcon v-if="icon.icon" :icon="'fa-light fa-' + icon.icon" />
          </span>
        </template>
      </label>
    </div>
  </template>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { checkboxChoiceVisibilityManager } from "@/services/utilities/checkbox-choice-visibility-manager";

export default {
  name: "CheckboxInputComponent",
  components: { FontAwesomeIcon },
  props: {
    model: {
      type: Object,
      required: true,
    },
    choices: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    filtered: {
      type: Boolean,
      required: false,
      default: false,
    },
    archivedFilter: {
      type: Boolean,
      required: false,
      default: false,
    },
    badgeFilterMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedBadges: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ["setChecked", "focus"],
  data() {
    return {
      itemModel: this.model,
    };
  },
  computed: {
    truncateChoiceLabel() {
      if (!this.model || !this.model.vars) {
        return false;
      }
      return !!(this.model.vars.attr && this.model.vars.attr["truncate-choice-label"]);
    },
  },
  methods: {
    badgeLabel(badge) {
      return this.badgeFilterMode ? badge.label : badge.label.toLowerCase();
    },

    isChoiceVisible(choice) {
      return checkboxChoiceVisibilityManager.isVisible(choice, {
        filtered: this.filtered,
        selectedBadges: this.selectedBadges,
        archivedFilter: this.archivedFilter,
      });
    },

    setChecked() {
      this.$emit("setChecked");
    },

    focus() {
      this.$emit("focus");
    },

    iconToDisplay(id) {
      return this.model.vars.attr["data-icons"].filter((element) => element.id === id);
    },

    getColor(icon) {
      const textDanger = ["link-slash"];
      let color;
      if (textDanger.includes(icon)) {
        color = "text-danger";
      }
      return color;
    },

    labelTextClass(choice) {
      return "custom-control-label__text" + (choice.class ? " " + choice.class : "");
    },
  },
};
</script>

<style scoped lang="scss">
.badged {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.badge + .badge {
  margin-left: 5px;
}

.is-invalid + label {
  &:before {
    border-color: $red;
  }
}

.custom-control-label {
  min-height: 20px;

  &.-truncated {
    display: flex;
    align-items: center;
    max-width: 100%;

    .custom-control-label__text {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      @include mobile {
        white-space: normal;
        overflow: visible;
        text-overflow: clip;
      }
    }

    > span:not(.custom-control-label__text) {
      flex-shrink: 0;
    }
  }
}

.small-label {
  font-size: 12px;
  line-height: 1.5;
  display: inline-block;
}
</style>
